import Axios from "./axiosInstance";

export const headerConfig = {
     //"Content-Type": "application/json;charset=UTF-8",
    //  'Content-Type': 'multipart/form-data'
}

export async function GET(url, config = {}) {
    try {
        const response = await Axios.get(url, {
            headers: {
                ...headerConfig
            },
            ...config,  // this will pass responseType or anything else
            withCredentials: true,
        });
        

        return response;
    } catch (error) {
        throw error;  // re-throw so you can catch it properly in caller
    }
}

export async function POST(url, requestData, headers) {
    try {
        const response = await Axios.post(url, requestData, {
            headers: {
                ...headerConfig, ...headers,
                // sessionID:sessionStorage.getItem('sessionID')
            },
            withCredentials: true,
        })

        return response;
    } catch (error) {
        return error;
    }
}
export async function PUT(url, requestData, headers) {
    try {
        const response = await Axios.put(url, requestData, {
            headers: {
                ...headerConfig, ...headers,
                // sessionID:sessionStorage.getItem('sessionID')
            },
            withCredentials: true,
        });

        return response;
    } catch (error) {
        return error;
    }
}

export async function PATCH(url, requestData, headers) {
    try {
        const response = await Axios.patch(url, requestData, {
            headers: {
                ...headerConfig, ...headers,
                // sessionID:sessionStorage.getItem('sessionID')
            },
            withCredentials: true,
        });

        return response;
    } catch (error) {
        return error;
    }
}

export async function DELETE(url, requestData) {
    try {
      const response = await Axios.delete(url, {
        data: requestData,
        headers: {
          ...headerConfig,
        },
        withCredentials: true,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
  